<template>
  <div v-if="reconciliationObject != null">
    <b-container fluid>
      <div class="content-title">
        <b-row>
          <h1>Reconcile VIBAN</h1>
          <div>
            <span style="background-color: #f54a00; color: #fff; border-radius: calc(.625rem - 2px); padding: 0.2rem 0.5rem;" v-if="balance < 0">Outstanding: -€{{ balance.toFixed(2).toString().slice(1) }}</span>
            <span style="background-color: #f54a00; color: #fff; border-radius: calc(.625rem - 2px); padding: 0.2rem 0.5rem;" v-else-if="balance > 0">Outstanding: €{{ balance.toFixed(2) }}</span>
            <span style="background-color: #00a63e; color: #fff; border-radius: calc(.625rem - 2px); padding: 0.2rem 0.5rem;" v-else>Balanced</span>
          </div>
        </b-row>
        <b-row>
          <span style="color: #4a5565;font-size: 1.125rem;"><span style="color: #155dfc; font-size: 1.2rem;">{{ reconciliationObject.VIBAN }}</span> • Client: {{ reconciliationObject.Reference1 }}</span>
        </b-row>
      </div>
    </b-container>
    <hr>

    <!-- payments / other events / orders -->
    <b-row class="cards-container">
      <!-- unmatched payments -->
      <b-col>
        <div>
          <div>
            <i class="fa-solid fa-dollar-sign"></i>
            <span>Unmatched Payments ({{ unmatchedPayments.length }})</span>
          </div>
          <div>
            <span class="btn btn-selection">Selected: {{ selectedPayments.length }}</span>
          </div>
        </div>
        <input type="text" class="filter-item-content" placeholder="Search payments..." @input="event => (search.payment = sanitize(event.target.value), searchPayment())"  @keyup.enter="searchPayment()"/>
        <div v-if="!paymentsLoading && search.paymentResults.length > 0">
          <div :class="['payment-container', {active: selectedPayments.some(p => p.date == payment.date && p.amount == payment.amount) }]" @click="parentClicked('payment_' + index)" v-for="(payment, index) in search.paymentResults" :key="index">
            <div>
              <label class="custom-checkbox" @click="parentClicked('payment_' + index)">
                <input type="checkbox" @click.stop :ref="'payment_' + index"
                  @value="payment"
                  @change="togglePaymentsSelected($event, index, payment)" />
                <span class="checkmark"></span>
              </label>
              <span>€{{Number(payment.LeftAmount).toFixed(2)}}</span>
            </div>
            <span>{{ payment.date }}</span>
          </div>
        </div>
        <div v-else-if="!paymentsLoading && unmatchedPayments.length > 0">
          <div :class="['payment-container', {active: selectedPayments.some(p => p.date == payment.date && p.amount == payment.amount) }]" @click="parentClicked('payment_' + index)" v-for="(payment, index) in unmatchedPayments" :key="index">
            <div>
              <label class="custom-checkbox" @click="parentClicked('payment_' + index)">
                <input type="checkbox" @click.stop :ref="'payment_' + index"
                  @value="payment"
                  @change="togglePaymentsSelected($event, index, payment)" />
                <span class="checkmark"></span>
              </label>
              <span>€{{Number(payment.LeftAmount).toFixed(2)}}</span>
            </div>
            <span>{{ formatDate(payment.CreationDate) }}</span>
          </div>
        </div>
        <div v-else>
          <span v-if="paymentsLoading">Loading...</span>
          <span v-else-if="this.search.payment.length > 0">No payments match your search</span>
          <span v-else>No unmatched payments</span>
        </div>
      </b-col>

      <!-- other events -->
      <b-col>
        <div>
          <div>
            <i class="fa-regular fa-credit-card"></i>
            <span>Other Events ({{ otherEvents.length }})</span>
          </div>
          <div style="display: flex; gap: 0.5rem; align-items: center;">
            <span class="btn btn-selection">Selected: {{ selectedOtherEvents.length }}</span>
            <button @click="openModal('create')" class="btn btn-outline-light"><i class="fa-regular fa-plus"></i>Create</button>
          </div>
        </div>
        <input type="text" class="filter-item-content" placeholder="Search events..." @input="event => (search.otherEvents = sanitize(event.target.value), searchOtherEvents())"  @keyup.enter="searchOtherEvents()"/>
        
        <div v-if="!otherEventsLoading && search.otherEventsResults.length > 0">
          <div :class="['otherEvent-container', {active: selectedOtherEvents.some(r => r.index == index) }]" @click="parentClicked('otherEvent_' + index)" v-for="(otherEvent, index) in search.otherEventsResults" :key="index">
            <div>
              <label class="custom-checkbox"  @click="parentClicked('otherEvent_' + index)">
                <input type="checkbox"
                  @click.stop
                  :ref="'otherEvent_' + index"
                  @value="otherEvent"
                  @change="toggleOtherEventsSelected($event, index, otherEvent)" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div>
              <div>
                <span>€{{Number(otherEvent.Amount).toFixed(2)}}</span>
                <div style="display: flex; align-items: baseline; gap: 1rem; text-wrap: nowrap;">
                  <div style="display: grid;">
                    <span>Created: {{ formatDate(otherEvent.CreationDate) }}</span>
                  </div>
                  <span class="btn-selection btn">{{ otherEvent.Type == 0 ? 'Refund' : 'Credit Note' }}</span>
                </div>
              </div>
              <span>{{ otherEvent.CustomerEmail ? otherEvent.CustomerEmail : '' }}</span>
            </div>
          </div>
        </div>
        <div v-else-if="!otherEventsLoading && otherEvents.length > 0">
          <div :class="['otherEvent-container', {active: selectedOtherEvents.some(r => r.index == index) }]" @click="parentClicked('otherEvent_' + index)" v-for="(otherEvent, index) in otherEvents" :key="index">
            <div>
              <label class="custom-checkbox" @click="parentClicked('otherEvent_' + index)">
                <input type="checkbox"
                  @click.stop
                  :ref="'otherEvent_' + index"
                  @value="otherEvent"
                  @change="toggleOtherEventsSelected($event, index, otherEvent)" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div>
              <div>
                <span>€{{Number(otherEvent.Amount).toFixed(2)}}</span>
                <div style="display: flex; align-items: baseline; gap: 1rem; text-wrap: nowrap;">
                  <div style="display: grid;">
                    <span>Created: {{ formatDate(otherEvent.CreationDate) }}</span>
                  </div>
                  <span class="btn-selection btn">{{ otherEvent.Type == 11 ?  'Refund':'Credit Note' }}</span>
                </div>
              </div>
              <span>{{ otherEvent.CustomerEmail ? otherEvent.CustomerEmail : '' }}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <span v-if="otherEventsLoading">Loading...</span>
          <span v-else-if="search.otherEvents.length > 0">No events match your search</span>
          <span v-else>No other events</span>
        </div>
      </b-col>

      <!-- unmatched orders -->
      <b-col>
        <div>
          <div>
            <i class="fa-regular fa-file-lines"></i>
            <span>Unmatched Orders ({{ unmatchedOrders.length }})</span>
          </div>
          <div>
              <span class="btn btn-selection">Selected: {{ selectedOrders.length }}</span>
          </div>
        </div>
        <input type="text" class="filter-item-content" placeholder="Search orders..." @input="event => (search.order = sanitize(event.target.value), searchOrder())"  @keyup.enter="searchOrder()"/>
        <div v-if="!ordersLoading && search.orderResults.length > 0">
          <div :class="['order-container',{active: selectedOrders.some(o => o.index == index)}]" @click="parentClicked('order_' + index)" v-for="(order, index) in search.orderResults" :key="index">
            <div>
              <label class="custom-checkbox" @click="parentClicked('order_' + index)">
                <input type="checkbox"
                  @click.stop
                  :ref="'order_' + index"
                  @value="order"
                  @change="toggleOrdersSelected($event, index, order)" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div>
              <div>
                <span>€{{Number(order.Amount).toFixed(2)}}</span>
                <div style="display: flex; align-items: center; gap: 1rem;">
                  <div style="display: grid;">
                    <span>Created: {{ formatDate(order.CreationDate) }}</span>
                    <span style="font-size: 0.8rem; color: #f54a00;">Due: {{ formatDate(order.CreationDate) }}</span>
                  </div>
                  <button @click="openModal('cancel'), helper.InvoiceIdentifier = order.Invoices[0].InvoiceIdentifier" class="btn-delete"><i class="fa-regular fa-circle-xmark"></i></button>
                </div>
              </div>
              <span>{{ order.Invoices[0].InvoiceIdentifier }}</span>
              <span>{{ order.CustomerEmail ? order.CustomerEmail : '' }}</span>
            </div>
          </div>
        </div>
        <div v-else-if="!ordersLoading && unmatchedOrders.length > 0">
          <div :class="['order-container',{active: selectedOrders.some(o => o.index == index)}]" @click="parentClicked('order_' + index)" v-for="(order, index) in unmatchedOrders" :key="index">
            <div>
              <label class="custom-checkbox" @click="parentClicked('order_' + index)">
                <input type="checkbox"
                  @click.stop
                  :ref="'order_' + index"
                  @value="order"
                  @change="toggleOrdersSelected($event, index, order)" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div>
              <div>
                <span>€{{Number(order.Amount).toFixed(2)}}</span>
                <div style="display: flex; align-items: center; gap: 1rem;">
                  <div style="display: grid;">
                    <span>Created: {{ formatDate(order.CreationDate) }}</span>
                    <span style="font-size: 0.8rem; color: #f54a00;">Due: {{ formatDate(order.CreationDate) }}</span>
                  </div>
                  <button @click="openModal('cancel'), helper.Amount = order.Amount, helper.InvoiceIdentifier = order.Invoices[0].InvoiceIdentifier" class="btn-delete"><i class="fa-regular fa-circle-xmark"></i></button>
                </div>
              </div>
              <span>{{ order.Invoices[0].InvoiceIdentifier }}</span>
              <span>{{ order.CustomerEmail ? order.CustomerEmail : '' }}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <span v-if="ordersLoading">Loading...</span>
          <span v-else-if="search.order.length > 0">No orders match your search</span>
          <span v-else>No unmatched orders</span>
        </div>
      </b-col>
    </b-row>

    <!-- modal -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content" style="max-height: 60rem; overflow-y: scroll;">

        <div>
          <div>
            <i :style="{color: eventType == 'Refund' ? '#f54a00' : '#9810fa'}" :class="['fa-regular', {'fa-file-xmark': selectedModal == 'create' && eventType == 'Credit', 'fa-slab-press fa-credit-card': selectedModal == 'create' && eventType == 'Refund', 'fa-circle-xmark': selectedModal == 'cancel' }]"></i>
            <h1>{{selectedModal == 'cancel' ? 'Cancel Order': eventType == 'Refund' ?'Create Refund':'Create Credit Note'}}</h1>
          </div>
          <i style="font-weight: bold; cursor: pointer;" @click="closeModal()" class="fa-regular fa-xmark"></i>
        </div>

        <span v-if="selectedModal == 'create' && eventType == 'Refund'">Create a refund for VIBAN {{ reconciliationObject.VIBAN }} that can be reconciled against orders</span>
        <span v-else-if="selectedModal == 'create' && eventType == 'Credit'">Create a credit note for VIBAN {{ reconciliationObject.VIBAN }} that can be reconciled against orders</span>
        <span v-else>Cancel order {{ helper.InvoiceIdentifier}} and create a cancellation entry for reconciliation</span>

        <div class="info-container">
          <i class="fa-regular fa-circle-exclamation"></i>
          <div>
            <span>How {{ selectedModal == 'cancel' ? 'Order Cancellation': eventType == 'Refund' ?'Refunds':'Credit Notes' }} Work:</span>
            <ul v-if="selectedModal == 'create'">
              <li>{{ eventType == 'Refund' ? 'Refunds are communicated by the merchant (already processed)':'Credit notes can be partial or full order amount'}}</li>
              <li>Created entries appear in the "Other Events" column</li>
              <li>Can be reconciled AGAINST orders to close them out</li>
              <li>Optional: Link to a specific order for context</li>
            </ul>
            <ul v-else>
              <li>The order will be marked as "Cancelled"</li>
              <li>A cancellation entry will be created in the transaction ledger</li>
              <li>You can then reconcile the order WITH its cancellation entry</li>
              <li>This closes out the order without requiring a payment</li>
            </ul>
          </div>
        </div>

        <div style="display: grid;" v-if="selectedModal == 'create'">
          <!-- event type dropdown -->
          <div class="filter-item">
            <span class="filter-item-title">Event Type *</span>
            <a id="event-picker-link"
              class="filter-item-content d-flex justify-content-between py-2 px-3"
              href="#">
              <span style="display: flex; gap: 0.5rem" class="fixed-span-size"><i :style="{color: eventType == 'Refund' ? '#f54a00' : '#9810fa'}" :class="['fa-regular', {'fa-file-xmark': selectedModal == 'create' && eventType == 'Credit', 'fa-slab-press fa-credit-card': selectedModal == 'create' && eventType == 'Refund'}]"></i>{{ eventType == 'Refund' ? 'Refund (Merchant Communicated)':'Credit Note' }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="page-chevron"></i>
            </a>
            <b-popover target="event-picker-link" triggers="focus" placement="bottom" custom-class="popover">
              <div>
                <span style="display: flex; gap: 0.5rem" :class="['popover-option', {'popover-option-selected':  eventType == 'Refund'}]" @click="eventType = 'Refund'">
                  <i style="color: #f54a00;" class="fa-regular fa-slab-press fa-credit-card"></i>Refund (Merchant Communicated)
                </span>
                <span style="display: flex; gap: 0.5rem" :class="['popover-option', {'popover-option-selected':  eventType == 'Credit'}]" @click="eventType = 'Credit'">
                  <i style="color: #9810fa;" class="fa-regular fa-file-xmark"></i>Credit Note
                </span>
              </div>
            </b-popover>
          </div>
          <span v-if="eventType == 'Refund'" style="color: #4a5565;">Merchant has communicated that a refund was processed to the customer</span>
          <span v-if="eventType == 'Credit'" style="color: #4a5565;">Record a credit note issued to the customer (can be partial or full amount)</span>

          <!-- amount -->
          <label for="amount">Amount (EUR) *</label>
          <input class="filter-item-content" placeholder="0.00" type="number" id="amount" :value="helper.Amount != null ? helper.Amount : selectedOrder != null ? selectedOrder.Amount : 0.00" @input="event => (helper.Amount = sanitize(event.target.value))">
          <small v-if="selectedOrder != null && helper.Amount != null && selectedOrder.Amount > helper.Amount" style="color: #f54a00;">⚠️ Partial refund: €{{ helper.Amount }} of €{{ Number(selectedOrder.Amount).toFixed(2) }}</small>
          <small v-if="selectedOrder != null && helper.Amount != null && selectedOrder.Amount == helper.Amount" style="color: #00a63e;">✓ Full refund amount</small>
          <small v-if="selectedOrder != null && helper.Amount == null" style="color: #00a63e;">✓ Full refund amount</small>

          <!-- reference -->
          <label for="reference">Reference (Optional)</label>
          <input class="filter-item-content" placeholder="Leave empty to auto-generate" type="text" id="reference" @input="event => (helper.InvoiceIdentifier = sanitize(event.target.value))">
          <small>Will auto-generate if left empty (e.g., REF-1234567890)</small>

          <!-- description -->
          <label for="description">Description (Optional)</label>
          <input class="filter-item-content" :placeholder=" eventType == 'Refund' ? 'Merchant communicated that refund was processed...':'Reason for credit note...'" type="text" id="description" @input="event => (helper.description = sanitize(event.target.value))">
          <small>Will auto-generate based on event details if left empty</small>

          <label for="">Customer Email (Optional)</label>
          <input class="filter-item-content" placeholder="customer@example.com" type="text" id="description" @input="event => (helper.email = sanitize(event.target.value))">

          <hr>

          <!-- ORDERS LIST -->
          <div style="display: grid; row-gap: 0.5rem;">
            <span class="filter-item-title">Link to Order (Optional)</span>
            <small>Link this {{ eventType == 'Refund' ? 'refund' : 'credit note'}} to a specific order for reference. This is optional - you can create standalone entries.</small>

            <input class="filter-item-content" type="text" name="searchOrder" id="searchOrder" placeholder="Search orders by reference, email, or status...">

            <div class="orders-container">
              <div>
                <span :class="{active: selectedOrder == null}"  @click="selectedOrder = null">No order selected (standalone entry)</span>
              </div>
              <div :class="{active: selectedOrder == order}" @click="selectedOrder = order" v-for="(order, index) in unmatchedOrders" :key="index">
                <div style="display: flex; justify-content: space-between;">
                  <span>{{ order.Invoices[0].InvoiceIdentifier }}</span>
                  <div>
                    <span></span>
                    <span>€{{ Number(order.Amount).toFixed(2) }}</span>
                  </div>
                </div>
                <span>Date: {{ formatDate(order.CreationDate) }} - Outstanding: €{{Number(order.Amount).toFixed(2)}}</span>
              </div>
            </div>
          </div>

          <div v-if="selectedOrder != null" style="display: grid; gap: 0;" class="info-container">
            <span style="font-weight: bold;">Selected Order: {{ selectedOrder.Invoices[0].InvoiceIdentifier }}</span>
            <span style="color: #4a5565;">Amount: €{{Number(selectedOrder.Amount).toFixed(2)}}</span>
            <span style="color: #4a5565;">Status:</span>
            <small v-if="eventType == 'Credit' && Number(helper.Amount) < Number(selectedOrder.Amount)" style="color: #155dfc;">💡 You can enter a partial amount for partial credit notes</small>
          </div>
        </div>

        <!-- Cancel -->
        <div style="display: grid; margin: 1rem 0rem;" v-else>
          <label for="reference">Cancellation Reason *</label>
          <textarea style="min-width: 100%; min-height: 5rem;" class="filter-item-content" placeholder="e.g., Customer cancelled order, Merchant cancelled due to stock unavailability..." id="reference" @input="event => (helper.description = sanitize(event.target.value))"></textarea>
        </div>

        <!-- SUMMARY -->
        <div class="summary-container">
          <span>Summary</span>
          <div v-if="selectedModal == 'cancel'">
            <span>Order:</span>
            <span>{{ helper.InvoiceIdentifier }}</span>
          </div>
          <div v-else>
            <span>Event Type:</span>
            <span>{{ eventType == 'Refund' ? 'Refund' : 'Credit Note' }}</span>
          </div>
          <div  v-if="selectedModal == 'create'">
            <span>Amount:</span>
            <span style="color: #f54a00;">€{{ helper.Amount ? Number(helper.Amount).toFixed(2) : selectedOrder != null ? Number(selectedOrder.Amount).toFixed(2) : '0.00'}}</span>
          </div>
          <div  v-if="selectedModal == 'create' && selectedOrder != null">
            <span>Linked Order:</span>
            <span>{{selectedOrder.Invoices[0].InvoiceIdentifier}}</span>
          </div>
          <div>
            <span>VIBAN:</span>
            <span style="font-weight: normal;">{{ reconciliationObject.VIBAN }}</span>
          </div>
          <div>
            <span>Client:</span>
            <span style="font-weight: normal;">{{ reconciliationObject.Reference1 }}</span>
          </div>
          <div v-if="selectedModal == 'cancel'">
            <span>Action:</span>
            <span>Cancel Order</span>
          </div>
        </div>

        <hr/>

        <div class="modal-content-buttons">
          <button class="btn-outline-light btn" @click="closeModal()">Cancel</button>
          <button :class="{disabled: helper.description == null || helper.description.length == 0}" v-if="selectedModal == 'cancel'" class="btn-outline btn-red" @click="cancelOrder()"><i  class="fa-regular fa-circle-xmark"></i>Cancel Order</button>
          <button v-else class="btn-outline btn-blue" @click="eventType == 'Refund' ? createRefund() : createCreditNote()">{{ eventType == 'Refund' ? 'Create Refund' : 'Create Credit Note' }}</button>
        </div>
      </div>
    </div>

    <!-- Balance summary -->
    <div class="balance-container">
      <h4>Balance summary</h4>
      <b-row>
        <b-col>
          <div>
            <span>Payments Selected:</span>
            <span style="color: #00a63e;">€{{ paymentsSum.toFixed(2) }}</span>
          </div>
          <div>
            <span>Refunds Selected:</span>
            <span style="color: #f54a00;">-€{{ Number(refundsSum).toFixed(2) }}</span>
          </div>
          <div v-if="creditSum > 0">
            <span>+ Write-offs (Credits):</span>
            <span style="color: #00a63e;">€{{ creditSum.toFixed(2) }}</span>
          </div>
          <hr>
          <div>
            <h4>Net Payments</h4>
            <span style="color: #00a63e;">€{{ (paymentsSum - refundsSum + creditSum).toFixed(2) }}</span>
          </div>
        </b-col>
        <b-col>
          <div>
            <span>Orders Selected:</span>
            <span style="color: #155dfc;">€{{ ordersSum.toFixed(2) }}</span>
          </div>
          <hr>
          <div>
            <h4>Net Orders:</h4>
            <span style="color: #155dfc;">€{{ ordersSum.toFixed(2) }}</span>
          </div>
          <hr>
          <div>
            <h4>Outstanding:</h4>
            <!-- <span v-if="balance == 0" style="color: #00a63e;">€0.00</span>
            <span v-else-if="balance < 0" style="color: #e7000b;">-€{{ balance.toFixed(2).toString().slice(1) }}</span>
            <span v-else style="color: #e7000b;">€{{ balance.toFixed(2) }}</span> -->
            <span v-if="balance === 0" style="color:#00a63e;">
              €0.00
            </span>

            <span v-else-if="balance < 0" style="color:#e7000b;">
              €{{ balance.toFixed(2) }}
            </span>

            <span v-else style="color:#e7000b;">
              €{{ Math.abs(balance.toFixed(2)) }}
            </span>
          </div>
          <span v-if="balance == 0" style="color: #00a63e;display: flex; gap: 0.5rem; align-items: center;"><i class="fa-regular fa-circle-check"></i>Balanced - Ready to reconcile</span>
        </b-col>
      </b-row>
    </div>

    <hr>
    <div style="display: flex; justify-content: space-between;">
      <button @click="closeDetail()" class="btn-outline-light btn">Cancel</button>
      <button :class="['btn btn-validate',{disabled: balance !== 0 || countSelected === 0}]" @click="rapprochement()">Complete Reconciliation</button>
    </div>
    <!-- alert modal for reconciliation complete -->
    <alert-modal v-if="isAlertOpen">
      <span><i class="fa-solid fa-circle-check"></i>Reconciliation sucessfully completed</span>
    </alert-modal>

    <div v-if="balance != 0" class="alert">
      <div>
        <i class="fa-regular fa-circle-exclamation"></i>
      </div>
      <div>
        <span v-if="balance > 0">Outstanding balance of €{{ Number(balance).toFixed(2) }}. Select additional payments/refunds or remove some orders to balance.</span>
        <span v-else>Outstanding balance of -€{{ Number(balance).toFixed(0).toString().slice(1) }}. Remove some selections to balance.</span>
      </div>
    </div>
    
  </div>
</template>

<script>
import AlertModal from '@/components/common/alertModal.vue';
import moment from 'moment'
export default {
  name: 'DetailReconciliationLedger',
  components: {
    'alert-modal': AlertModal
  },
  props: {
    reconciliationObject: Object,
  },
  data(){
    return {
      unmatchedPayments: [
      ],
      otherEvents: [
      ],
      unmatchedOrders: [
      ],
      refunds: [],
      creditnotes: [],
      helper: {
        InvoiceIdentifier: null,
        Amount: null,
        reference: null,
        description: null,
        email: null
      },
      selectedModal: null,
      eventType: 'Refund',
      selectedItems: [],
      selectedPayments: [],
      selectedOtherEvents: [],
      selectedOrders: [],
      selectedOrder: null,
      search: {
        payment: '',
        otherEvents: '',
        order: '',
        paymentResults: [],
        otherEventsResults: [],
        orderResults: []
      },
      balance : 0,
      paymentsSum: 0,
      ordersSum: 0,
      refundsSum: 0,
      creditSum: 0,
      otherEventsSum: 0,
      countSelected: 0,
      isModalOpen : false,
      isAlertOpen: false,
      otherEventsLoading: false,
      ordersLoading: false,
      paymentsLoading: false,
    }
  },
  created(){
    this.otherEvents = [];
    this.ordersLoading = true;
    this.paymentsLoading = true;
    this.otherEventsLoading = true;

    let filter = {
      Reference1: this.reconciliationObject.Reference1,
      GetDetails: 1,
      NonReconcilie: 1
    }

    this.$engine.services.payments.getTransactions(filter)
    .then(resp => {
      this.unmatchedPayments = resp.data.Transactions.filter(payment =>
        payment.Type == 1 &&
        payment.Direction == 0
      )

      this.unmatchedOrders = resp.data.Transactions.filter(invoice =>
        invoice.Invoices &&
        invoice.Invoices.length > 0 &&
        invoice.Invoices[0].InvoiceType == 'Standard' &&
        invoice.Type == 0 &&
        invoice.Direction == 1
      )

      this.otherEvents = [...this.otherEvents, ...resp.data.Transactions.filter(event => event.Direction == 0 && event.Type == 3 || event.Direction == 1 && event.Type == 11)]
      this.otherEventsLoading = false;
      this.paymentsLoading = false;
      this.ordersLoading = false;
    })
  },
  methods: {
    closeDetail () {
      this.$emit("close-reconciliation")
    },
    rapprochement () {
      let data = {
        Invoice: this.selectedOrders.map(obj => {if (obj.Type == 0 && obj.Direction == 1) return obj.Invoices[0].IdInvoice}),
        Transaction: this.selectedPayments.map(obj => { if (obj.Type == 1 && obj.Direction == 0) return obj.IdTransaction}).concat(this.selectedOtherEvents.map(obj => {if (( obj.Type == 3|| obj.Type == 11 ) && obj.Direction == 0) return obj.IdTransaction}))
      }
      
      this.$engine.services.payments.rapprochement(data)
      .then(resp => {
        if(resp.statusText == 'OK'){
          let filter = {
            Reference1: this.reconciliationObject.Reference1,
            GetDetails: 1,
            NonReconcilie: 1
          }
          this.getTransactions(filter)
          this.isAlertOpen = true;
          setTimeout(()=>{
            this.isAlertOpen = false;
          }, 3000)
        }
      })
    },
    togglePaymentsSelected(event, index, payment) {
      const checked = event.target.checked;
      if (checked) {
        if (!this.selectedPayments.includes(index)) {
          payment.index = index
          this.selectedPayments.push(payment)
          this.countSelected++
        }
      } else {
        this.selectedPayments = this.selectedPayments.filter(item => item.index !== index)
        this.countSelected--
      }
      this.isBalanced()
    },
    toggleOtherEventsSelected(event, index, refund) {
      const checked = event.target.checked;
      if (checked) {
        if (!this.selectedOtherEvents.includes(index)) {
          refund.index = index
          this.selectedOtherEvents.push(refund)
          this.countSelected++
        }
      } else {
        this.selectedOtherEvents = this.selectedOtherEvents.filter(item => item.index !== index)
        this.countSelected--
      }

      this.isBalanced()
    },
    toggleOrdersSelected(event, index, order) {
      const checked = event.target.checked;
      if (checked) {
        if (!this.selectedOrders.includes(index)) {
          order.index = index
          this.selectedOrders.push(order)
          this.countSelected++
        }
      } else {
        this.selectedOrders = this.selectedOrders.filter(item => item.index !== index)
        this.countSelected--
      }
      this.isBalanced()
    },
    parentClicked(index) {
      let checkbox = this.$refs[index];
      if (Array.isArray(checkbox)) {
        checkbox = checkbox[0];
      }
      checkbox.click();
    },
    searchPayment(){
      this.paymentsLoading = true;
      let filter = {
        GroupPaymentIdentifier2: this.reconciliationObject.Reference1,
        Search: this.search.payment,
        NonReconcilie: 1
      }
      this.$engine.services.payments.getTransactions(filter)
      .then(resp => {
        this.unmatchedPayments = resp.data.Transactions.filter(invoice =>
          invoice.Type == 1 &&
          invoice.Direction == 0
        )
        this.paymentsLoading = false;
      })
    },
    searchOtherEvents(){
      this.otherEventsLoading = true;

      let filter = {
        Reference1: this.reconciliationObject.Reference1,
        Search: this.search.otherEvents,
        NonReconcilie: 1
      }

      this.$engine.services.payments.getTransactions(filter)
      .then(resp => {
        this.otherEvents = [...resp.data.Transactions.filter(event => event.Direction == 0 && event.Type == 3 || event.Direction == 1 && event.Type == 11)]
        this.otherEventsLoading = false;
      })
    },
    searchOrder(){
      this.ordersLoading = true;
      let filter = {
        GroupPaymentIdentifier2: this.reconciliationObject.Reference1,
        Search: this.search.order,
        NonReconcilie: 1
      }
      this.$engine.services.payments.getTransactions(filter)
      .then(resp => {
        this.unmatchedOrders = resp.data.Transactions.filter(invoice =>
          invoice.Invoices &&
          invoice.Invoices.length > 0 &&
          invoice.Invoices[0].InvoiceType == 'Standard' &&
          invoice.Direction == 1
        )
        this.ordersLoading = false;
      })
    },
    openModal(selected){
      this.isModalOpen = true
      this.selectedModal = selected
    },
    closeModal(){
      this.helper = {
        InvoiceIdentifier: null,
        Amount: null,
        reference: null,
        description: null,
        email: null
      }
      this.isModalOpen = false
      this.selectedModal = null
    },
    isBalanced() {
      const toNumber = (v) => Number(v) || 0

      this.paymentsSum = this.selectedPayments.reduce((sum, p) => sum + toNumber(p.LeftAmount),0)

      this.ordersSum = this.selectedOrders.reduce((sum, o) => sum + toNumber(o.Amount),0)

      this.refundsSum = this.selectedOtherEvents.filter(e => e.Type == 11).reduce((sum, e) => sum + toNumber(e.Amount), 0)

      this.creditSum = this.selectedOtherEvents.filter(e => e.Type == 3).reduce((sum, e) => sum + toNumber(e.Amount), 0)

      //const netPayments = this.paymentsSum - this.refundsSum + this.creditSum

      this.balance = this.ordersSum + this.refundsSum - this.paymentsSum - this.creditSum
    },
    formatDate (dateObj){
      let timestamp = Date.parse(dateObj)
      let date = new Date(timestamp).toLocaleDateString()
      return date;
    },
    selectOrder(order){
      this.helper.InvoiceIdentifier = order
    },
    setCredit(value) {
      this.modals[this.selectedModal].isCredit = value;
    },
    getTransactions (filter) {
      this.otherEvents = [];
      this.selectedPayments = []
      this.selectedOtherEvents = []
      this.selectedOrders = []
      this.isBalanced()
      this.otherEventsLoading = true;
      this.paymentsLoading = true;
      this.ordersLoading = true;

      this.$engine.services.payments.getTransactions(filter)
      .then(resp => {
        this.unmatchedPayments = resp.data.Transactions.filter(payment =>
          payment.Type == 1 &&
          payment.Direction == 0
        )

        this.unmatchedOrders = resp.data.Transactions.filter(invoice =>
          invoice.Invoices &&
          invoice.Invoices.length > 0 &&
          invoice.Invoices[0].InvoiceType == 'Standard' &&
          invoice.Type == 0 &&
          invoice.Direction == 1
        )

        this.otherEvents = [...this.otherEvents, ...resp.data.Transactions.filter(event => event.Direction == 0 && (event.Type == 3 || event.Type == 11))]
        this.otherEventsLoading = false;
        this.paymentsLoading = false;
        this.ordersLoading = false;
      })
    },
    cancelOrder(){
      if(this.helper.description != null && this.helper.description.length > 0){
        let invoice = {
          "InvoiceIdentifier": this.helper.InvoiceIdentifier,
          //"Amount": this.helper.Amount,
          "Status": 11
        }

        this.$engine.services.payments.putInvoice(invoice)
        .then(resp => {
          console.log(resp)
          if(resp.status == 200){
            this.closeModal()
            let filter = {
              GroupIdentifier2: this.reconciliationObject.Reference1,
              GetDetails: 1,
              NonReconcilie: 1
            }
            this.getTransactions(filter)
          }
        })
      }
    },
    createRefund(){
      if((this.helper.Amount != null && this.helper.Amount > 0) || (this.selectedOrder != null && this.selectedOrder.Amount > 0 )) {

        let invoice = {
          "InvoiceIdentifier": this.generateReference('REF-'),
          "PaymentDate": moment(),
          "Amount": this.helper.Amount ? Number(this.helper.Amount).toFixed(2) : this.selectedOrder != null ? Number(this.selectedOrder.Amount).toFixed(2) : '',
          'CustomerEmail': this.helper.email,
          "Type": 'Refund',
          "Description": this.helper.description,
          "Reference1": this.reconciliationObject.Reference1
        }

        this.$engine.services.payments.createInvoice(invoice)
        .then(resp => {
          if(resp.status == 201){
            this.closeModal()
            let filter = {
              Reference1: this.reconciliationObject.Reference1,
              GetDetails: 1,
              NonReconcilie: 1
            }
            this.getTransactions(filter)
          }
        })

      }
    },
    createCreditNote(){
      if((this.helper.Amount != null && this.helper.Amount > 0) || (this.selectedOrder != null && this.selectedOrder.Amount > 0 )) {

        let invoice = {
          "InvoiceIdentifier": this.generateReference('CRE-'),
          "PaymentDate": moment(),
          "Amount": this.helper.Amount ? Number(this.helper.Amount).toFixed(2) : this.selectedOrder != null ? Number(this.selectedOrder.Amount).toFixed(2) : '',
          'CustomerEmail': this.helper.email,
          "Type": 'CreditNote',
          "Description": this.helper.description,
          "Reference1": this.reconciliationObject.Reference1
        }

        this.$engine.services.payments.createInvoice(invoice)
        .then(resp => {
           if(resp.status == 201) {
             this.closeModal()
             let filter = {
               Reference1: this.reconciliationObject.Reference1,
               GetDetails: 1,
               NonReconcilie: 1
             }
             this.getTransactions(filter)
           }
        })
      }
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    },
    async checkAllocation (data) {
      const resp = await this.$engine.services.payments.getInvoices({ InvoiceIdentifier: data })

      return (
        resp.data.Invoices.length === 0
      )
    },
    generateReference (prefix){
      let reference = prefix + (Math.random().toString(20).substr(2, 6) + '-' + Math.random().toString(20).substr(2, 3)).toUpperCase()

      if (!this.checkAllocation(reference)) return this.generateReference(prefix)

      return reference
    }
  }
}
</script>
<style scoped>

  .btn-red{
    background-color: #e7000b;
    border-color: #e7000b;
    color: white;
  }

  .btn-red:hover{
    background-color: #c10007;
    border-color: #c10007;
  }

  .btn-blue{
    background-color: #155dfc;
    border-color: #155dfc;
    color: white;
  }

  .btn-blue:hover{
    background-color: #1d4ed8;
    border-color: #1d4ed8;
  }

small{
  color: #6a7282;
  margin: 0.5rem 0rem 1rem 0rem;
}

.btn-delete{
  color: #e7000b;
  font-size: 1.2rem;
  border-radius: calc(.625rem - 2px);
  background-color: #fef2f2;
  border: none;
  height: 2.5rem;
  width: 2.5rem;
}

.orders-container{
  border: 1px solid #0000001a;
  border-radius: .625rem;
  margin: 1rem 0rem;
  max-height: calc(.25rem * 48);
  height: fit-content;
  overflow-y: scroll;
}

.orders-container>div:not(:first-child)>div>span, .orders-container>div:not(:first-child)>div>div>span{
  font-weight: bold;
  color: #000;
}

.orders-container>div:not(:first-child)>span{
  color: #4a5565;
  font-size: .75rem;
}

.orders-container>div:first-child{
  padding: 0.5rem;
  display: grid;
}


.orders-container>div:first-child>span.active{
  background-color: #eff6ff;
  border: 1px solid #8ec5ff;
}


.orders-container>div:first-child>span{
  font-style: italic;
  color: #4a5565;
  padding: 0.75rem;
  border-radius: 0.25rem;
  cursor: pointer;
}

.orders-container>div:first-child>span:hover{
  background-color: #f6f3f4;
}

.orders-container>div:not(:first-child):hover, .orders-container>div:first-child>span:hover {
  background-color: #f8f8f8 !important;
}

.orders-container>div{
  padding: calc(.25rem * 4);
}

.orders-container>div:not(:first-child).active{
  border: none;
  border-left: 4px solid #2b7fff;
  border-radius: 0%;
  background-color: #eff6ff;
}

.orders-container>div:not(:last-child){
  border-bottom: 1px solid #0000001a;
}

.summary-container{
  display: grid;
  row-gap: 0.5rem;
  padding: calc(.25rem * 4);
  background-color: #f8f8f8 !important;
  border: 1px solid #0000001a;
  border-radius: .625rem;
  margin: 1rem 0rem;
}

.summary-container>span{
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0.5rem 0rem;
}

.summary-container>div>span:last-child {
  font-weight: bold;
}

.summary-container>div{
  display: flex;
  justify-content: space-between;
}

.info-container{
  display: flex;
  align-items: baseline;
  gap: 1rem;
  padding: calc(.25rem * 4);
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: .625rem;
  margin: 1rem 0rem;
}

.info-container>i {
  color: #717182;
  font-size: calc(.25rem * 4);
}

.info-container>div>span>span{
  color: #1c398e;
  font-weight: bold;
}

.info-container>div>span{
  font-weight: bold;
  color: #717182;
}

.info-container>div>ul{
  color: #717182;
  padding: 0rem 0rem 0rem 1rem;
  margin: 1rem 0rem;
}

.modal-content>span{
  color: #4a5565;
  font-weight: normal;
}

.modal-content>div:first-child{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-content>div:first-child>div{
  display: flex;
  align-items: baseline;
  gap: 1rem;
}

.modal-content>div:first-child>div>h1, .modal-content>div:first-child>div>i{
  font-size: 1.5rem;
}

.btn-selection{
  font-weight: bold !important;
  display: flex;
  min-height: 0.5rem !important;
  gap: 1rem;
  padding: 0.25rem 0.5rem !important;
  align-items: center;
  border: 1px solid #0000001a;
  border-radius: calc(0.75rem - 2px);
  color: #0a0a0a;
  font-size: .85rem;
  cursor: default !important;
}

.btn-validate{
  color: #ffffff;
  background-color: #00a63e;
}

.disabled{
  opacity: 0.5;
  pointer-events: none;
  white-space: nowrap;
}

h4{
  font-weight: bold;
  color: #000 !important;
  padding: 0%;
}

.payment-container, .otherEvent-container, .order-container, .helper-container{
  cursor: pointer;
  border-radius: calc(0.625rem - 2px);
  transition: all 0.1s ease-in;
}

.payment-container.active{
  background-color: #dcfce7 !important;
  border: 1px solid #05df72 !important;
  color: #000;
}

.payment-container:hover{
  border: 1px solid #05df72 !important;
}

.otherEvent-container.active{
  background-color: oklch(95.4% 0.038 75.164) !important;
  border: 1px solid oklch(75% 0.183 55.934) !important;
  color: #000;
}

.otherEvent-container:hover{
  border: 1px solid oklch(75% 0.183 55.934) !important;
}

.helper-container.active{
  background-color: #f3e8ff !important;
  border: 1px solid #c27aff !important;
  color: #000;
}

.helper-container:hover{
  border: 1px solid #c27aff !important;
}

.cards-container{
  display: flex;
  gap: 1.5rem;
  margin: 2rem 0rem;
}

.cards-container>div>input{
  background-color: #fff !important;
  width: 100%;
  margin: 1rem 0rem;
}

.cards-container>div>input:focus-visible{
  border: 1px solid #a1a1a1;
  box-shadow: 0 0 0 3px color-mix(in oklab, oklch(.708 0 0) 50%, transparent);
}

.cards-container>div{
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  height: 18rem;
  padding: 1.2rem;
}

.cards-container>div>div:last-child>span{
  color: #6a7282;
  display: flex;
  justify-content: center;
}

.cards-container>div:nth-child(1){
  background-color: #f0fdf4;
}

.cards-container>div>div:last-child{
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  height: 8rem;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.cards-container>div>div:last-child::-webkit-scrollbar{
  display: none;
}

.payment-container, .otherEvent-container{
  padding: calc(.25rem * 3);
  background: #fff;
  border: 1px solid #0000001a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #6a7282;
}

.order-container, .otherEvent-container{
  padding: calc(.25rem * 3);
  background: #fff;
  border: 1px solid #0000001a;
  display: flex;
  align-items: baseline;
  gap: 1rem;
  color: #6a7282;
}

.order-container.active{
  background-color: #dbeafe !important;
  border: 1px solid #51a2ff !important;
  color: #000;
}

.order-container:hover{
  border: 1px solid #51a2ff !important;
}

.order-container>div:last-child, .otherEvent-container>div:last-child{
  display: grid;
  width: 100%;
}

.order-container>div:last-child>div, .otherEvent-container>div:last-child>div{
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.order-container>div:last-child>span, .otherEvent-container>div:last-child>span{
  font-weight: bold;
}

.order-container>div:last-child>div>span:first-child{
  color: #1d4ed8;
  font-weight: bold;
}

.payment-container>span, .order-container>div:last-child>div>span:last-child, .otherEvent-container>div:last-child>div>span:last-child{
  font-size: 0.85rem;
}

.otherEvent-container>div:last-child>div>span:first-child{
  color: oklch(75% 0.183 55.934);
  font-weight: bold;
}

.payment-container>div{
  display: flex;
  gap: 1rem;
  align-items: center;
}

.payment-container>div{
color: #008236;
font-weight: bold;
}

.cards-container>div:nth-child(2){
  background-color: #fff7ed;
}

.cards-container>div:nth-child(3){
  background-color: #eff6ff;
}

.cards-container>div>div:first-child{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cards-container>div:nth-child(1)>div:first-child>div>i{
  color: #00a63e;
}

.cards-container>div:nth-child(2)>div:first-child>div>i{
  color: #f54a00;
}

.cards-container>div:nth-child(3)>div:first-child>div>i{
  color: #155dfc;
}

.cards-container>div>div:first-child>div:first-child>span{
  font-weight: bold;
}

.balance-container{
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  height: 18rem;
  padding: 1rem;
  margin-bottom: 2rem;
}

.balance-container>h4, .balance-container>div>div>div>h4{
  font-size: 1.2rem;
}

.balance-container>div>div>div>span{
  color: #4a5565;
}

.balance-container>div>div>div>span:last-child{
  font-weight: bold;
}

.balance-container>div>div>div{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.nav-container{
  height: 2.5rem;
  padding: 0.2rem;
  border-radius: calc(1rem - 2px);
  background-color: #e7e7e7 !important;
}

.nav-container>div{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: none;
  border-radius: calc(0.625rem + 4px);
  color: #000;
  font-weight: bold;
  cursor: pointer;
}

.nav-container>div .active{
  background-color: #fff;
  cursor: default;
}

.panel-container{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
  margin: 2rem 0rem;
}

.panel-btn{
  padding: calc(.25rem * 4);
  display: flex;
  align-items: center;
  gap: 1rem;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  background-color: #fff;
  height: 6rem;
  cursor: pointer;
}

.panel-btn:hover{
  background-color: #eff6ff;
  border-color: #51a2ff;
}

.panel-btn>div>i{
  background-color: #dbeafe;
  color: #155dfc;
}

.panel-btn-red{
  border-color: #ffc9c9;
}

.panel-btn-yellow{
  border-color: #fed7aa;
}

.panel-btn-yellow>div>i{
  color: #f54a00;
  background-color: #ffedd4;
}

.panel-btn-red:hover{
  border-color: #ff6467;
  background-color: #fef2f2;
}


.panel-btn-red>div>i{
  color: #e7000b;
  background-color: #ffe2e2;
}

.panel-btn-yellow:hover{
  border-color: #ff8904;
  background-color: #fff7ed;
}

.panel-btn>div:first-child>i{
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  padding: 0.5rem;
  border-radius: calc(0.625rem - 2px);
}

.panel-btn>div:last-child{
  display: grid;
}

.panel-btn>div:last-child>span:first-child{
  font-weight: bold;
}

.panel-btn>div:last-child>span:last-child{
  font-size: 0.875rem;
  color: #6a7282;
}

.alert{
  display: flex;
  gap: 1rem;
  margin: 1rem -1rem;
  padding: 1rem 0rem;
  align-items: center;
  max-height: 6rem;
  background-color: #fefce8;
  border: 1px solid #fef08a;
  border-radius: calc(1rem - 2px);
  padding: 1.5rem 1rem;
  color: #a16207;
}

.navigation{
  min-height: 3rem;
  position: sticky;
  border-bottom: 1px solid #0000001a;
  box-shadow: 0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a;
}

.navigation>div>div{
  padding: 1rem;
  gap: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  font-weight: bold;
  cursor: pointer;
}

.navigation>div>div>span{
  background-color: #eff6ff;
  font-size: 0.75rem;
  font-weight: lighter;
  padding: 0.3rem;
  border-radius: calc(0.625rem - 2px);
  width: 8rem;
  white-space: nowrap;
}

.navigation>div>div>i{
  font-size: 1rem;
}

.navigation>div>div:last-child>i:last-child{
  cursor: pointer;
  padding: 0.4rem;
}

.navigation>div>div:last-child>i:last-child:hover{
  background-color: rgb(207, 207, 207);
  border-radius: .25rem;
}

.active{
  background-color: #fff;
  border: 2px solid #155dfc;
  border-radius: calc(0.625rem - 2px);
  color: #155dfc;
}

.alert>div{
  display: grid;
}

.alert>div:first-child>i{
  font-size: 1.5rem;
  color: #d08700;
}

.alert>div:last-child>span:first-child{
  color: #733e0a;
  font-weight: bold;
}

.inactive{
  color: #0a0a0a;
  opacity: .5;;
  pointer-events: none;
  outline-style: none;
}

.content-title{
  margin: 1.5rem 0rem;
}


.content-title>div>span{
  color: #000000a6;
  font-size: 1.1rem;
}

.filters{
  margin: 2rem 0rem;
}

.filters-container{
  width: 100%;
  margin: 2rem 0rem 0rem 0rem;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  background-color: #fff;
  padding: 2rem;
}

.filters-items{
  display: grid;
  grid-template-columns: 7fr 4fr 1fr;
  padding: 0rem 1rem;
}

.filters-items>div:nth-child(2){
  display: flex;
  gap: 1rem;
}
</style>